import LegalDocument from './LegalDocument';

export default function PrivacyPolicy() {
    return <LegalDocument kind="privacy" />;
}
